export const kingaMrowka = {
    'mydrId': 'kinkaszalkowska',
    'firstName': 'Kinga',
    'lastName': 'Mrówka',
    'profession': 'Psychoterapeuta w trakcie szkolenia, psychodietetyk',
    'avatar': 'kinga-mrowka.webp',
    'slug': 'psychoterapeuta-psychodietetyk-kinga-mrowka',
    'locations': ['bydgoszcz'],
    'services': [
        ['psychoterapy', 'children'],
        ['psychoterapy', 'adult'],
        ['psychoterapy', 'pair'],
        ['psychoterapy', 'parents'],
    ]
}